<template>
    <Row :gutter="20" v-if="model">
      <Col :span="24">
        <Card>
          <Row v-if="model.repeated === 0">
            <Col :span="Number(item.width)*2" v-for="item in items" class="view-var" :key="item.id">
              <view-var :model="item"></view-var>
            </Col>
          </Row>
          <Row v-if="model.repeated === 1">
            <Col :span="24">
              <view-repeat-domain :items="items"></view-repeat-domain>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
</template>

<script>
import ViewVar from '@/components/query/ViewVar'
import ViewRepeatDomain from '@/components/query/ViewRepeatDomain'
import { ViewDomainData } from '@/api/query'

export default {
  name: 'query-form-data',
  data: () => ({
    model: null,
    items: []
  }),
  components: {
    'view-repeat-domain': ViewRepeatDomain,
    'view-var': ViewVar
  },
  methods: {
    init: function (query) {
      const data = {
        crfid: query.crfid,
        usubjid: query.usubjid,
        visitid: query.visitid,
        formid: query.formid
      }
      ViewDomainData(data).then(async res => {
        this.model = res.model
        this.items = res.items
      })
    }
  }
}
</script>

<style scoped>
.view-var {
  padding: 6px 0;
}
</style>
